import React from 'react';
import { SIMULATOR_GUIDE_CONTENT } from '../content/SimulatorGuideContent';
import './SimulatorGuide.css';

import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export default function SimulatorGuide({ isOpen, onClose }) {
    if (!isOpen) return null;

    return (
        <div className="guide-overlay" onClick={onClose}>
            <div className="guide-modal" onClick={e => e.stopPropagation()}>
                <header className="guide-header">
                    <h2>📘 SAFEC+ Simulator Guide</h2>
                    <button className="close-btn" onClick={onClose}>×</button>
                </header>

                <div className="guide-body">
                    {/* Top Sticky Navigation */}
                    <div className="guide-toc-bar">
                        <span className="toc-label">Jump to:</span>
                        <div className="toc-pills">
                            {SIMULATOR_GUIDE_CONTENT.map(section => (
                                <a key={section.id} href={`#${section.id}`} className="toc-pill">
                                    {section.title.replace('Section ', '')}
                                </a>
                            ))}
                        </div>
                    </div>

                    <div className="guide-content full-width">
                        {SIMULATOR_GUIDE_CONTENT.map(section => (
                            <section key={section.id} id={section.id} className="guide-section">
                                <h3 className="guide-section-header">{section.title}</h3>

                                {section.subsections && section.subsections.length > 0 && (
                                    <div className="subsection-list">
                                        <h4>In this section:</h4>
                                        <ul>
                                            {section.subsections.map((sub, idx) => (
                                                <li key={idx}>{sub}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}

                                <div className="markdown-content">
                                    <ReactMarkdown
                                        remarkPlugins={[remarkGfm]}
                                    >
                                        {section.content}
                                    </ReactMarkdown>
                                </div>
                            </section>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
